import { useEffect } from 'react';
import useStateOfFareCalendar from './useStateOfFareCalendar';
import { useStore } from '@/contexts/StoreContext';
import { useQuery } from './useQuery';
import useFareCalendarBaseQuery from './useFareCalendarBaseQuery';
import { useRouter } from 'next/router';
import useFetchFareCalendar from './useFetchFareCalendar';

export const useFareCalendarSetup = () => {
  const store = useStore();
  const router = useRouter();
  const { isRoundTrip, query } = useQuery();
  const state = useStateOfFareCalendar(store, isRoundTrip);

  const baseQuery = useFareCalendarBaseQuery(query, router);
  useFetchFareCalendar(state.fareCalendarQuery || baseQuery, isRoundTrip, state);

  useEffect(() => {
    if (query) {
      state.updateFareCalendarBaseQuery(query);
      state.updateFareCalendarQuery(query);
    }
  }, []);
};
